import { getAttr } from '../features/helpers/apiHelpers';
import { compareDates } from '../features/helpers/dateHelpers';
import { SORTING_KEYS } from '../constants/sortingKeys';

export const comparators = {
  hearingOverview: {
    [SORTING_KEYS.DEADLINE_SOONEST]: (aHearing, bHearing) =>
      compareDates(aHearing.deadline, bHearing.deadline),
    [SORTING_KEYS.DEADLINE_LATEST]: (aHearing, bHearing) =>
      compareDates(aHearing.deadline, bHearing.deadline) * -1,

    [SORTING_KEYS.RELEASE_SOONEST]: (aHearing, bHearing) =>
      compareDates(aHearing.startDate, bHearing.startDate),
    [SORTING_KEYS.RELEASE_LATEST]: (aHearing, bHearing) =>
      compareDates(aHearing.startDate, bHearing.startDate) * -1,

    [SORTING_KEYS.ALPHABETICAL]: (aHearing, bHearing) =>
      aHearing.title.toLowerCase().localeCompare(bHearing.title.toLowerCase()),
    [SORTING_KEYS.ALPHABETICAL_REVERSE]: (aHearing, bHearing) =>
      aHearing.title.toLowerCase().localeCompare(bHearing.title.toLowerCase()) *
      -1,
  },
  editSubjectAreas: {
    [SORTING_KEYS.TITLEALPHABETICAL]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
    [SORTING_KEYS.TITLEALPHABETICAL_REVERSE]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()) * -1,

    [SORTING_KEYS.NUMOFHEARINGS_DESC]: (a, b) =>
      (b.numberOfHearings || 0) - (a.numberOfHearings || 0),
    [SORTING_KEYS.NUMOFHEARINGS_ASC]: (a, b) =>
      (a.numberOfHearings || 0) - (b.numberOfHearings || 0),

    [SORTING_KEYS.STATUS_DESC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()) * -1,
    [SORTING_KEYS.STATUS_ASC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()),
  },
  editCityAreas: {
    [SORTING_KEYS.TITLEALPHABETICAL]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
    [SORTING_KEYS.TITLEALPHABETICAL_REVERSE]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()) * -1,

    [SORTING_KEYS.NUMOFHEARINGS_DESC]: (a, b) =>
      (b.numberOfHearings || 0) - (a.numberOfHearings || 0),
    [SORTING_KEYS.NUMOFHEARINGS_ASC]: (a, b) =>
      (a.numberOfHearings || 0) - (b.numberOfHearings || 0),

    [SORTING_KEYS.STATUS_DESC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()) * -1,
    [SORTING_KEYS.STATUS_ASC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()),
  },
  editHearingTypes: {
    [SORTING_KEYS.TITLEALPHABETICAL]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
    [SORTING_KEYS.TITLEALPHABETICAL_REVERSE]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()) * -1,

    [SORTING_KEYS.NUMOFHEARINGS_DESC]: (a, b) =>
      (b.numberOfHearings || 0) - (a.numberOfHearings || 0),
    [SORTING_KEYS.NUMOFHEARINGS_ASC]: (a, b) =>
      (a.numberOfHearings || 0) - (b.numberOfHearings || 0),

    [SORTING_KEYS.STATUS_DESC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()) * -1,
    [SORTING_KEYS.STATUS_ASC]: (a, b) =>
      a.status.toLowerCase().localeCompare(b.status.toLowerCase()),

    [SORTING_KEYS.ISINTERNAL_YES]: (a, b) =>
      a.isInternal.toLowerCase().localeCompare(b.isInternal.toLowerCase()),
    [SORTING_KEYS.ISINTERNAL_NO]: (a, b) =>
      a.isInternal.toLowerCase().localeCompare(b.isInternal.toLowerCase()) * -1,
  },
  renderHearings: {
    [SORTING_KEYS.SORT_FIELDS]: (a, b) =>
      getAttr(a, 'displayOrder') - getAttr(b, 'displayOrder'),
  },
  kleHierarchies: {
    [SORTING_KEYS.KLE_NUMBER]: (a, b) => a.number.localeCompare(b.number),
  },
  editFieldTemplates: {
    [SORTING_KEYS.TITLEALPHABETICAL]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
    [SORTING_KEYS.TITLEALPHABETICAL_REVERSE]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()) * -1,
  },
  updateInvitationGroups: {
    [SORTING_KEYS.TITLEALPHABETICAL]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
    [SORTING_KEYS.TITLEALPHABETICAL_REVERSE]: (a, b) =>
      a.title.toLowerCase().localeCompare(b.title.toLowerCase()) * -1,
  },
};

export const isEquivalent = (a, b) => {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
};
